<template>
  <el-card style="width: 100%">
    <div
      slot="header"
      class="clearfix"
    >
      <span>Áfa kimutatás - ügynöki</span>
    </div>
    <div class="filter-container">
      <el-form
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="20" style="display: flex; ">
            <el-form-item
              label="Dátum"
            >
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="dateRangeOptions"
                style="margin-right: 10px;"
                @change="fetchData"
              />
            </el-form-item>
            <el-form-item style="margin-right: 10px;"
                          label="Beszállító"
            >
              <el-select
                v-model="partner"
                filterable
                remote
                :remote-method="searchPartner"
                :loading="partnerLoading"
                placeholder="Gépelj a kereséshez..."
                style="width: 100%;"
                value-key="id"
                @change="fetchData"
                clearable
              >
                <el-option
                  v-for="p in partners"
                  :key="p.company.id"
                  :value="p"
                  :label="p.company.name"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="Fizetési mód"
            >
              <el-select
                v-model="paymentMethod"
                style="width: 100%;"
                value-key="id"
                @change="fetchData"
                clearable
              >
                <el-option
                  v-for="p in paymentMethods"
                  :key="p.id"
                  :value="p"
                  :label="p.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div style="text-align: right; margin-top: 24px;">
              <el-button
                :loading="downloadLoading"
                icon="el-icon-download"
                @click="download"
              >
                Letöltés
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div v-loading="loading">
      <el-table
        :key="tableKey"
        :data="vatValues.values"
        style="width: 100%"
        row-key="id"
        border
      >
        <el-table-column
          width="50"
          prop="count"
          label="#"
          fixed
        >
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column>
        <el-table-column
          width="150"
          prop="count"
          label="Képviselő"
          show-overflow-tooltip
          fixed
        >
          <template slot-scope="scope">
            {{ scope.row.creator_user_name }}
          </template>
        </el-table-column>

        <div v-for="vat in vatValues.vats">
          <el-table-column
            width="100"
            prop="count"
            :label="'Nettó ' + vat + '%'"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row['net_price_' + vat] | currency }}
            </template>
          </el-table-column>

          <el-table-column
            width="100"
            prop="count"
            :label="'Áfa ' + vat + '%'"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row['vat_' + vat] | currency }}
            </template>
          </el-table-column>

          <el-table-column
            width="100"
            prop="count"
            :label="'Bruttó ' + vat + '%'"
            align="right"
          >
            <template slot-scope="scope">
              {{ scope.row['gross_price_' + vat] | currency }}
            </template>
          </el-table-column>
        </div>

        <el-table-column
          width="140"
          prop="count"
          label="Számla br."
          align="right"
          fixed="right"
        >
          <template slot-scope="scope">
            {{ scope.row.gross_price | currency }}
          </template>
        </el-table-column>

      </el-table>
    </div>
  </el-card>
</template>

<script>
  import moment from 'moment';
  import {saveAs} from 'file-saver';


  export default {
    components: {},
    data() {
      const start = moment()
        .startOf('year')
        .format('Y-MM-DD');
      const end = moment()
        .format('Y-MM-DD');
      return {
        tableKey: 0,
        itemLoading: 0,
        vatValues: {},
        loading: false,
        downloadLoading: false,
        userLoading: false,
        representativeUserId: null,
        representativeUsers: [],
        partners: [],
        partner: null,
        partnerLoading: false,
        paymentMethod: null,
        paymentMethods: [
          {
            id: 'cash',
            name: 'Készpénz',
          },
          {
            id: 'transfer',
            name: 'Utalás',
          },
        ],
        dateRange: [start, end],
        dateRangeOptions: {
          firstDayOfWeek: 1,
          shortcuts: [{
            text: 'Aktuális hét',
            onClick(picker) {
              const start = moment()
                .weekday(1)
                .toDate();
              const end = moment()
                .weekday(7)
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hét',
            onClick(picker) {
              const start = moment()
                .subtract({weeks: 1})
                .weekday(1)
                .toDate();
              const end = moment()
                .subtract({weeks: 1})
                .weekday(7)
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális hónap',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .toDate();
              const end = moment()
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző hónap',
            onClick(picker) {
              const start = moment()
                .subtract({months: 1})
                .startOf('month')
                .toDate();
              const end = moment()
                .subtract({months: 1})
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző 3 hónap',
            onClick(picker) {
              const start = moment()
                .subtract({months: 3})
                .startOf('month')
                .toDate();
              const end = moment()
                .subtract({months: 1})
                .endOf('month')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Aktuális év',
            onClick(picker) {
              const start = moment()
                .startOf('year')
                .toDate();
              const end = moment()
                .endOf('year')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Előző év',
            onClick(picker) {
              const start = moment()
                .subtract({years: 1})
                .startOf('year')
                .toDate();
              const end = moment()
                .subtract({years: 1})
                .endOf('year')
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'YTD',
            onClick(picker) {
              const start = moment()
                .startOf('year')
                .toDate();
              const end = moment()
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'MTD',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .toDate();
              const end = moment()
                .toDate();
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      };
    },
    computed: {},
    watch: {},
    async mounted() {
      this.fetchData();

      this.userLoading = true;
      try {
        this.representativeUsers = await axios.get('api/users/representatives');
      } catch (e) {
      }
      this.userLoading = false;
    },
    methods: {
      async download() {
        this.downloadLoading = true;
        try {
          const excel = await axios({
            url: `api/reports/vat/representative/summary/download`,
            method: 'POST',
            responseType: 'blob',
            data: {
              from: this.dateRange[0],
              to: this.dateRange[1],
              partner_id: this.partner && this.partner.id,
              payment_method: this.paymentMethod ? this.paymentMethod.id : null,
            },
          });
          saveAs(excel, `vatrepresentativesummary.xlsx`);
        } catch (e) {
          console.log(e)
        }
        this.downloadLoading = false;
      },

      async fetchData() {
        this.loading = true;
        let query = `api/reports/vat/representative/summary/${this.dateRange.join(',')}?`

        if (this.partner) {
          query += `partner_id=${this.partner.id}`
        }

        if (this.paymentMethod) {
          query += `payment_method=${this.paymentMethod.id}`
        }

        this.vatValues = await axios.get(query);
        this.loading = false;
      },

      async searchPartner(query) {
        if (query !== '') {
          this.partnerLoading = true;
          this.partners = await this.$store.dispatch('partner/search', '?name=' + query + '&is_supplier=true');
          this.partnerLoading = false;
        }
      },
    },
  };
</script>
<style lang="scss">
  .stockValue-table {
    .el-table__footer {
      td {
        .cell {
          font-weight: 700;
        }
      }
    }
  }
</style>
